
<div class="container">


   <h2 class="content-heading">
         <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
            <i class="fa fa-plus mr-5"></i>Add Lectionary Item
          </button>
       
          Lectionary Items
    </h2>


  <div class="blockX">

    <!--
    <div class="block-header block-header-default">
        <h3 class="block-title"></h3>
    </div>
  -->
  <div style="padding-bottom:20px;"> 
    <app-lectionary-item-search (searchItems)="search($event)"></app-lectionary-item-search>
  </div>
 

    <div  *ngIf="isLoading==false">

        <div *ngIf="entities == null || entities.length == 0">
            There are no results to show
        </div>

        <div *ngIf="entities != null && entities.length > 0">
        <div class=row>

            <div class="col-sm-5">
 
              Show
              <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
                <option value=15>15</option>
                  <option value=30>30</option>
                  <option value=60>60</option>
                  <option value=99999>All</option>
              </select>
              entries  

          </div>
        
          <div class="col-sm-7 text-right"> 

              <span style="margin-right:20px">
                  Status: 
                  <select  (change)="changeStatusOption()" [(ngModel)]="searchStatus">
                    <option [ngValue]=null></option>
                    <option  [ngValue]=true>Active</option>
                    <option  [ngValue]=false>Inactive</option>
                  </select>
                </span>
      

            <span style="margin-right:20px">
              Proofed: 
              <select  (change)="changeProofedOption()" [(ngModel)]="searchProofed">
                <option [ngValue]=null></option>
                <option  [ngValue]=true>Yes</option>
                <option  [ngValue]=false>No</option>
              </select>
            </span>
              Filter: <input type="text" [(ngModel)]="searchName">
          </div>
          
        </div>
 
        <div class="table-responsive table yearDataTable">

            <div class="xrow header gridRow row">
                <div class="col-md-1"></div>
                <div class="col-md-4">Name</div>
                <div class="col-md-1">Text Source</div>
                <div class="col-md-1">Item Type</div>
                <div class="col-md-1">Is Active</div>
                <div class="col-md-2">Proofed</div> 
                <div class="col-md-2 text-right">Actions</div>
            </div>

            <div id="scrollableTable">
                <div class="">

                    <div *ngFor="let obj of entities | lectionaryItemSearchFilter: searchName: searchProofed: searchStatus | paginate: { itemsPerPage: numberOfRecords, currentPage: pageNumber }" class="dateRow gridRow row">
                      <div class="col-md-1">{{obj.Id}}</div>
                      <div class="col-md-4">
                        {{obj.ItemAdjustedName}}
                        <span *ngIf="obj.IsValid == false" [matTooltip]="'This name is not valid according to LAPI validation'" class="fa fa-warning fa-2"></span> 
                      </div>
                      <div class="col-md-1">
                          {{obj.Source}}
                          <BR>
                          {{obj.PageNumber}}
                      </div>

                      <div class="col-md-1">{{obj.LectionaryItemType}}</div>
                      <div class="col-md-1">{{obj.IsActive}}</div>
                      <div class="col-md-2">{{obj.ProofedByValue}}</div>

                    <div class="col-md-2 text-right">

                            <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                                <i class="fa fa-pencil"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                                <i class="fa fa-times"></i>
                            </button>
                         
                      </div>

                </div>
                </div>

            </div>




          </div>




 <div id="pageButtons" style="overflow: auto">
 
  {{ renderPaginationItemStatus(p) }} of {{ p.getTotalItems()}} entries
 
  <pagination-template #p="paginationApi" (pageChange)="pageNumber = $event" class="float-right">
   
    <div class="custom-pagination">
  
      <ul class="pagination pagination">
    
        <li class="page-item">
          <a class="page-link" *ngIf="!p.isFirstPage()" (click)="p.previous();">
            <i class="fa fa-angle-double-left"></i>
          </a>
        </li>
  
        <li class="page-item" *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
          <a class="page-link" (click)="p.setCurrent(page.value);" *ngIf="p.getCurrent() !== page.value">
            <span>{{ page.label }}</span>
          </a>
          <a class="page-link" *ngIf="p.getCurrent() === page.value">
            <span>{{ page.label }}</span>
          </a>
        </li>
  
        <li class="page-item">
          <a class="page-link"  *ngIf="!p.isLastPage()" (click)="p.next();">
              <i class="fa fa-angle-double-right"></i>
          </a>
        </li>
 

     
  
      </ul> 
  
    </div>
  
  </pagination-template>

  </div>

  <div>
 
      <div>
        Total Proofed: 
        {{countTotalProofed}}
      </div>
      <div>
        Total Not Proofed:
        {{countTotalNotProofed}}
      </div>
      
  </div>

</div>


    </div>

    <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

  </div>

  </div>

